import { takeLatest, put, call, select } from 'redux-saga/effects';
import { SET_USER_PERMISSION_SAGA } from "../sagaTypes";
import { loaderAction, userPermissionAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { USER_PERMISSION_FORM_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/set_user_permission`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerSetUserPermission(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('id', args.data.id);
        formData.append('role', args.data.role);
        formData.append('coach', args.data.coach);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Закрываем форму редактирования прав пользователя
            yield put(userPermissionAction(USER_PERMISSION_FORM_INITIAL));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherSetUserPermission() {
    yield takeLatest(SET_USER_PERMISSION_SAGA, workerSetUserPermission);
}